// @pageboss/ui Card — the ONE card shell (spec §4: components that naturally
// repeat are shared; no upfront component-library project — exactly four
// primitives live here). Styling uses ONLY @pageboss/tokens utility names,
// the vocabulary BOTH apps' stylesheets define; host apps must include
// `@source ".../packages/ui/src"` so Tailwind v4 scans these classes.
import type { ReactNode } from 'react';

export interface CardProps {
  title?: string;
  children: ReactNode;
  footer?: ReactNode;
  className?: string;
}

export function Card({ title, children, footer, className }: CardProps) {
  return (
    <section
      className={['rounded-lg border border-border bg-surface-card shadow-sm', className]
        .filter(Boolean)
        .join(' ')}
    >
      {title ? (
        <h3 className="border-b border-border-subtle px-5 py-3 text-sm font-semibold text-text-primary">
          {title}
        </h3>
      ) : null}
      <div className="px-5 py-4">{children}</div>
      {footer ? <div className="border-t border-border-subtle px-5 py-3">{footer}</div> : null}
    </section>
  );
}
